/* eslint-disable */
export const closeModal = modal => {
  if (modal == null) return;
  modal.classList.remove('active');
  $('body').removeClass('modal-is-active');
  overlay.classList.remove('active');
};
export const openModal = modal => {
  if (modal == null) return;
  $('body').addClass('modal-is-active');
  modal.classList.add('active');
  overlay.classList.add('active');
};
export const renderModalContent = template => {
  $('.modal').empty();
  $('.modal').append(template);
};